// Chnages worning modal component
import React from "react";

const ChangesWarningModal = ({ closeChangesWarningModal, message }) => {
  const onClickOk = () => {
    closeChangesWarningModal(true);
  };
  const closeModal = () => {
    closeChangesWarningModal(false);
  };

  return (
    <>
      <div id="saveas-modal" className="m-auto">
        <div className="modal-dialog m-0">
          <div className="modal-content">
            <div className="close-icon text-right">
              <button type="button" className="close" data-dismiss="modal" onClick={() => closeChangesWarningModal()}>
                <span aria-hidden="true">
                  <i className="fa fa-times text-red" />
                </span>
              </button>
            </div>
            <h4 className="modal-title text-white text-uppercase">Save Changes?</h4>
            <div className="rotation-option" style={{ marginTop: "30px" }}>
              <div className="form-group">
                <div style={{ color: "white" }}>{message}</div>
              </div>
            </div>
            <div className="d-flex justify-content-center">
              <button type="submit" className="btn btn-red mr-5" onClick={onClickOk} style={{ width: "150px" }}>
                Save
              </button>
              <button type="button" className="btn btn-black" onClick={closeModal}>
                Discard
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ChangesWarningModal;
